export default __webpack_public_path__ + "static/media/Screenshot_1619918992.06bcd801.png";